export default "__VITE_ASSET__Dk0uF8Ru__"